/**
 * Like Array.prototype.map, but for objects. Take an object and create a new one by transforming each value with a function.
 * @function mapObject
 * @param {Object} obj - The object whose values and keys you want to map over.
 * @param {Function} callback - The function to transform each value. Called with value and key (in that order).
 * @return {Object} - The new object.
 * @example
 * const original = { a: 1, b: 2, c: 3 }
 * const transformed = mapObject(original, (val) => val * 2)
 * // { a: 2, b: 4, c: 6 }
 *
 * const withKey = mapObject(original, (val, key) => key.repeat(val))
 * // { a: 'a', b: 'bb', c: 'ccc' }
 */

const mapObject = (obj, callback) => {
    const keys = Object.keys(obj)
    const newObj = {}
  
    for (const key of keys) {
      // eslint-disable-line no-restricted-syntax
      newObj[key] = callback(obj[key], key)
    }
  
    return newObj
  }
  
  export default mapObject
  


// WEBPACK FOOTER //
// ./src/utils/mapObject.js